import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { fetchCaptcha } from "../services";
import { DEFAULT_CAPTCHA_HEIGHT, DEFAULT_CAPTCHA_WIDTH } from "../constants";
export var useFetchCaptcha = function useFetchCaptcha(_ref) {
  var captchaKey = _ref.captchaKey,
    setCaptchakey = _ref.setCaptchakey,
    refreshToken = _ref.refreshToken;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    imgSrc = _useState2[0],
    setCaptchaImgSrc = _useState2[1];
  useEffect(function () {
    // eslint-disable-next-line no-void
    void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$fetchCaptcha, pic, captchakey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchCaptcha(_objectSpread(_objectSpread({
              w: DEFAULT_CAPTCHA_WIDTH,
              h: DEFAULT_CAPTCHA_HEIGHT
            }, captchaKey ? {
              key: captchaKey
            } : {}), {}, {
              r: new Date().getTime()
            }));
          case 2:
            _yield$fetchCaptcha = _context.sent;
            pic = _yield$fetchCaptcha.pic;
            captchakey = _yield$fetchCaptcha.captchakey;
            setCaptchakey === null || setCaptchakey === void 0 || setCaptchakey(captchakey);
            setCaptchaImgSrc(pic);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }, [captchaKey, refreshToken]);
  return imgSrc;
};